module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image6.7e42da74.jpg";